import React from "react";
import { apiService } from "../../../services/index";

function ClaimAgencyModal({ agencyName, agencyNumber, show, onClose }) {
  const [firstName, setFirstName] = React.useState("");
  const [lastName, setLastName] = React.useState("");
  const [firstNameError, setFirstNameError] = React.useState("");
  const [lastNameError, setLastNameError] = React.useState("");
  const [submitting, setSubmitting] = React.useState(false);
  const [claimError, setClaimError] = React.useState("");

  const uw211 = window.UW211 || {};
  const isNonDeniedAgencyUser = uw211.IS_NON_DENIED_AGENCY_USER || false;

  // User data comes from the Header component's props (serialized via current_user.to_json)
  // which includes: first_name, last_name, email, agency: { number, name }
  // The Header receives it as a JSON string; we parse it similarly.
  const user = React.useMemo(() => {
    return (window.UW211 && window.UW211.CURRENT_USER) || null;
  }, []);

  const userAgencyName = isNonDeniedAgencyUser ? (user?.agency?.name || null) : null;
  const userFirstName = user?.first_name || "";
  const userLastName = user?.last_name || "";
  const userEmail = user?.email || "";

  React.useEffect(() => {
    if (show) {
      setFirstName(userFirstName);
      setLastName(userLastName);
      setFirstNameError("");
      setLastNameError("");
      setClaimError("");
    }
  }, [show, userFirstName, userLastName]);

  if (!show) return null;

  function handleClaim(e) {
    e.preventDefault();
    const trimmedFirst = firstName.trim();
    const trimmedLast = lastName.trim();

    setFirstNameError("");
    setLastNameError("");

    let hasError = false;
    if (!trimmedFirst) {
      setFirstNameError("First name can't be blank");
      hasError = true;
    }
    if (!trimmedLast) {
      setLastNameError("Last name can't be blank");
      hasError = true;
    }
    if (hasError) return;

    setSubmitting(true);
    apiService
      .post(`/agencies/${agencyNumber}/claim`, {
        first_name: trimmedFirst,
        last_name: trimmedLast,
      })
      .then((res) => {
        window.location = res.location;
      })
      .catch(() => {
        setSubmitting(false);
        setClaimError("Unable to claim this agency. Please try again.");
      });
  }

  return (
    <div
      className="modal send-referral in update-type-selection-modal claimAgencyModal"
      role="dialog"
      tabIndex="-1"
      style={{ zIndex: 9999, display: "block" }}
    >
      <div className="modal-dialog" role="document">
        <div className="modal-content referral-modal-content">
          <div className="modal-header">
            <a
              className="close-modal referral-ico cancel-icon"
              aria-label="Close"
              onClick={onClose}
              role="button"
              tabIndex={0}
            />
          </div>

          {isNonDeniedAgencyUser ? (
            <div className="modal-body">
              <p>
                You are already associated with the agency{" "}
                <span className="agency-name">{userAgencyName}</span>.
              </p>
              <p>
                Make changes to your agency&apos;s resources{" "}
                <a href="/my211/agency_data">here.</a>
              </p>
            </div>
          ) : (
            <div className="content modal-body referral-input-box">
              <h3 className="referral-header dark-blue-text">
                Claim your agency
              </h3>
              <p className="agency-name">{agencyName}</p>

              {(!userFirstName || !userLastName) && (
                <form className="add-name">
                  <label className="label first-name">First name *</label>
                  <input
                    className={`input login-input first-name${firstNameError ? " agency-error-input" : ""}`}
                    name="First Name"
                    placeholder="First name *"
                    value={firstName}
                    onChange={(e) => setFirstName(e.target.value)}
                    readOnly={!!userFirstName}
                  />
                  {firstNameError && (
                    <div className="first-name-input-error agency-error-message">
                      {firstNameError}
                    </div>
                  )}
                  <label className="label last-name">Last name *</label>
                  <input
                    className={`input login-input last-name${lastNameError ? " agency-error-input" : ""}`}
                    name="Last Name"
                    placeholder="Last name *"
                    value={lastName}
                    onChange={(e) => setLastName(e.target.value)}
                    readOnly={!!userLastName}
                  />
                  {lastNameError && (
                    <div className="last-name-input-error agency-error-message">
                      {lastNameError}
                    </div>
                  )}
                </form>
              )}

              {claimError && <div className="text-danger" style={{ marginBottom: 10 }}>{claimError}</div>}
              <a
                className="btn btn-primary claim-agency pointer claim-agency-submit-button"
                name="Claim Agency"
                onClick={handleClaim}
                role="button"
                tabIndex={0}
                style={submitting ? { pointerEvents: "none", opacity: 0.6 } : {}}
              >
                Claim this agency
              </a>
            </div>
          )}

          <div className="modal-footer referral-modal-content">
            <p>
              Not {userEmail}?{" "}
              <a href="/users/sign_out" data-method="delete">
                Log out.
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ClaimAgencyModal;
